import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateJobTitle as apiUpdate } from "../../api/apiJobTitles";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateJobTitle() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: editJobTitle, isPending: isUpdate, data: results, error } = useMutation({
        mutationFn: ({ req, id }) => apiUpdate(req, id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["jobTitles"] });
            navigate('/job-titles');
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { editJobTitle, isUpdate, error, results };
}
